import {
  LegalClientEntity,
  LegalClientRepresentativeEntity,
} from 'api/types/entity';
import { parseFullName } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { usePageTitle } from 'libs/navigation';

export const useLegalPageTitle = (
  legalClient: LegalClientEntity | null,
  legalClientRepresentative: LegalClientRepresentativeEntity | null
) => {
  const { t } = useTranslation();

  let fullName = legalClientRepresentative
    ? t('client.legalRepresentative.title', {
        name: parseFullName(legalClientRepresentative),
      })
    : '';

  fullName += fullName && legalClient ? ` - ${legalClient.fullName}` : '';

  usePageTitle(fullName);
};
